import { render } from "./BankDataForm.vue?vue&type=template&id=4e746e03"
import script from "./BankDataForm.vue?vue&type=script&lang=js"
export * from "./BankDataForm.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__